import React from "react";
import { Block, Button, FieldArray, Input, PortletAccordionItem, TextInput } from "../../../../components";
import colors from "../../../../utils/colors";

export default function ListBenefits({ value = [] }) {
    return (
        <FieldArray
            name={"benefits"}
            render={(arrayHelpers) => {
                return (
                    <>
                        {value.map((_item, index) => {
                            return (
                                <PortletAccordionItem
                                    key={index}
                                    title={"Benefit" + " #" + (index + 1)}
                                    onClickDelete={() => arrayHelpers.remove(index)}
                                    onClickMoveDown={() => arrayHelpers.move(index, index + 1)}
                                    onClickMoveUp={() => arrayHelpers.move(index, index - 1)}
                                >
                                    <Block>
                                        <Input Component={TextInput} name={`benefits[${index}].item`} placeholder="Item" />
                                    </Block>
                                </PortletAccordionItem>
                            );
                        })}
                        <Block>
                            <Button width="100%" icon="plus_16px" color={colors.grey01} onClick={() => arrayHelpers.insert(value.length, {})} />
                        </Block>
                    </>
                );
            }}
        />
    );
}